import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_COUNTRIES_LOAD,
    ACTION_COUNTRIES_LOAD_BY_ID,

    ACTION_COUNTRIES_SAVE,

    ACTION_COUNTRIES_CREATE,

    ACTION_COUNTRIES_VALIDATE,

    ICountryLoadAction,
    ICountryLoadByIdAction,
    ICountryLoadFailureAction,
    ICountryLoadSuccessAction,

    ICountrySaveAction,
    ICountrySaveSuccessAction,
    ICountrySaveFailureAction,

    ICountryCreateAction,
    ICountryCreateSuccessAction,
    ICountryCreateFailureAction,

    ICountryValidateAction,
    ICountryValidateSuccessAction,
    ICountryValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/countries";
import { countriesApi } from "../services/countries";


export const
    getCountriesEpic = (action$): Observable<ICountryLoadSuccessAction | ICountryLoadFailureAction> => {
        return action$
            .ofType(ACTION_COUNTRIES_LOAD)
            .mergeMap((_action: ICountryLoadAction) => {
                return countriesApi
                    .getCountries()
                    .map(response =>
                        LoadSuccess(response.countries, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getCountryByIdEpic = (action$): Observable<ICountryLoadSuccessAction | ICountryLoadFailureAction> => {
        return action$
            .ofType(ACTION_COUNTRIES_LOAD_BY_ID)
            .mergeMap((action: ICountryLoadByIdAction) => {
                return countriesApi
                    .getCountryById(action.id)
                    .map(response =>
                        LoadSuccess(response.country, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setCountryEpic = (action$): Observable<ICountrySaveSuccessAction | ICountrySaveFailureAction> => {
        return action$
            .ofType(ACTION_COUNTRIES_SAVE)
            .mergeMap((action: ICountrySaveAction) => {
                return countriesApi
                    .setCountry(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.country, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createCountryEpic = (action$): Observable<ICountryCreateSuccessAction | ICountryCreateFailureAction> => {
        return action$
            .ofType(ACTION_COUNTRIES_CREATE)
            .mergeMap((_action: ICountryCreateAction) => {
                return countriesApi
                    .createCountry()
                    .map(response =>
                        CreateSuccess(
                            response.country,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateCountryEpic = (action$): Observable<ICountryValidateSuccessAction | ICountryValidateFailureAction> => {
        return action$
            .ofType(ACTION_COUNTRIES_VALIDATE)
            .mergeMap((action: ICountryValidateAction) => {
                return countriesApi
                    .validateCountry(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.country, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



